__turbopack_context__.v({
  "breadcrumbItem": "NewsHeader-module-scss-module__NgZSWq__breadcrumbItem",
  "breadcrumbLink": "NewsHeader-module-scss-module__NgZSWq__breadcrumbLink",
  "breadcrumbList": "NewsHeader-module-scss-module__NgZSWq__breadcrumbList",
  "breadcrumbSeparator": "NewsHeader-module-scss-module__NgZSWq__breadcrumbSeparator",
  "breadcrumbWrapper": "NewsHeader-module-scss-module__NgZSWq__breadcrumbWrapper",
  "container": "NewsHeader-module-scss-module__NgZSWq__container",
  "contentWrapper": "NewsHeader-module-scss-module__NgZSWq__contentWrapper",
  "date": "NewsHeader-module-scss-module__NgZSWq__date",
  "description": "NewsHeader-module-scss-module__NgZSWq__description",
  "tag": "NewsHeader-module-scss-module__NgZSWq__tag",
  "tagWrapper": "NewsHeader-module-scss-module__NgZSWq__tagWrapper",
  "title": "NewsHeader-module-scss-module__NgZSWq__title",
  "topArea": "NewsHeader-module-scss-module__NgZSWq__topArea",
});
